var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "mini-program-share-wrapper"
  }, [_c("van-overlay", {
    attrs: {
      show: _vm.visible,
      "lock-scroll": false,
      "z-index": "3006"
    }
  }, [_c("div", {
    staticClass: "wrapper"
  }, [_c("div", {
    staticClass: "share-content"
  }, [_c("div", {
    ref: "shareContentRef",
    staticStyle: {
      background: "linear-gradient(#f8efff, #e0f4ff)"
    }
  }, [_c("div", {
    staticClass: "share-header"
  }, [_c("van-image", {
    attrs: {
      src: _vm.logoUrl,
      height: "36px",
      width: "120px"
    }
  })], 1), _c("div", {
    staticClass: "share-body"
  }, [_c("div", {
    staticClass: "question-box-wrapper"
  }, [_c("div", {
    staticClass: "question-box",
    domProps: {
      innerHTML: _vm._s(_vm.renderMessage(_vm.question.content))
    }
  })]), _c("div", {
    staticClass: "answer-box m-t-32",
    domProps: {
      innerHTML: _vm._s(_vm.renderMarkDown(_vm.answer.content))
    }
  }), _vm.isOverFlow ? _c("van-image", {
    staticClass: "overflow-backdrop-filter",
    attrs: {
      src: _vm.filterBase64
    }
  }) : _vm._e()], 1), _c("div", {
    staticClass: "share-footer"
  }, [_c("van-image", {
    attrs: {
      src: _vm.footerUrl
    }
  }), _c("div", {
    staticClass: "share-qrcode"
  }, [_c("van-image", {
    attrs: {
      src: _vm.qrCodeBase64
    }
  })], 1)], 1)])])])])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };